import React from "react";
import App from "./App";
import "./index.css";

import { CookiesProvider } from "react-cookie";

import { render } from 'react-dom';

import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import loginReducer from "./reducers/loginReducer";
import utilsReducer from "./reducers/utilsSlice";
import AuthWrapper from "./components/authWrapper";

const store = configureStore({
  reducer: {
    login: loginReducer,
    utils: utilsReducer,
  },
});

const root = document.getElementById("root");
render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <CookiesProvider>
          <AuthWrapper>
            <App />
          </AuthWrapper>
        </CookiesProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  root
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
